module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-bg"
  }, [_c('backTitleBar'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bgColor == 'bg-fff'),
      expression: "bgColor == 'bg-fff'"
    }],
    staticClass: "page-flex bg-fff page"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.shopName),
      expression: "entity.shopName"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.type == 'name'),
      expression: "type == 'name'"
    }],
    staticClass: "input-show",
    attrs: {
      "type": "text",
      "placeholder": "请输入名称"
    },
    domProps: {
      "value": (_vm.entity.shopName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "shopName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.deviceSn),
      expression: "entity.deviceSn"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.type == 'sn'),
      expression: "type == 'sn'"
    }],
    staticClass: "input-show",
    attrs: {
      "type": "text",
      "placeholder": "请输入SN码"
    },
    domProps: {
      "value": (_vm.entity.deviceSn)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "deviceSn", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "click sure-btn",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n            确定\n        ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bgColor == 'bg-gray'),
      expression: "bgColor == 'bg-gray'"
    }],
    staticClass: "page-flex bg-gray"
  }, [_c('div', {
    staticClass: "gray-page"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == 'address'),
      expression: "type == 'address'"
    }],
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-item bd-bot click",
    on: {
      "click": function($event) {
        _vm.$refs.pickerArea.popupShow = true
      }
    }
  }, [_c('div', {
    staticClass: "item-name"
  }, [_vm._v("所在地区")]), _vm._v(" "), _c('div', {
    staticClass: "item-value area"
  }, [_vm._v(_vm._s(_vm.entity.areaname.split(",").join(" ")))]), _vm._v(" "), _c('div', {
    staticClass: "item-icon alifont icon-fanhui1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-item"
  }, [_c('div', {
    staticClass: "item-name"
  }, [_vm._v("详细地址")]), _vm._v(" "), _c('div', {
    staticClass: "item-value"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address),
      expression: "entity.address"
    }],
    attrs: {
      "rows": "3",
      "placeholder": "请输入详细地址"
    },
    domProps: {
      "value": (_vm.entity.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "address", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == 'lnglat'),
      expression: "type == 'lnglat'"
    }]
  }, [_c('div', {
    staticClass: "search-content",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('div', {
    staticClass: "alifont icon-xpsousuo"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addr),
      expression: "addr"
    }],
    staticClass: "content-input",
    attrs: {
      "type": "text",
      "placeholder": "搜索位置"
    },
    domProps: {
      "value": (_vm.addr)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchByStationName.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addr = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search-btn click",
    on: {
      "click": _vm.searchByStationName
    }
  }, [_vm._v("搜索")])]), _vm._v(" "), _c('div', {
    staticClass: "bg-fff pd-25 mt-30",
    staticStyle: {
      "border-radius": ".24rem"
    }
  }, [_c('div', {
    staticClass: "allmap",
    staticStyle: {
      "width": "100%",
      "height": "6rem"
    },
    attrs: {
      "id": "allmap"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "lnglat"
  }, [_c('span', [_vm._v("经度：" + _vm._s(_vm.point.lng))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": ".8rem"
    }
  }, [_vm._v("纬度：" + _vm._s(_vm.point.lat))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == 'deviceVersionId'),
      expression: "type == 'deviceVersionId'"
    }],
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-item bd-bot click",
    on: {
      "click": function($event) {
        _vm.showPicker = true
      }
    }
  }, [_c('div', {
    staticClass: "item-name"
  }, [_vm._v("硬件版本")]), _vm._v(" "), _c('div', {
    staticClass: "item-value area"
  }, [_vm._v(_vm._s(_vm.entity.deviceVersionName))]), _vm._v(" "), _c('div', {
    staticClass: "item-icon alifont icon-fanhui1"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "click sure-btn",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n                确定\n            ")])])]), _vm._v(" "), _c('pickerArea', {
    ref: "pickerArea",
    on: {
      "change": _vm.handleConfirm
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showPicker),
      callback: function($$v) {
        _vm.showPicker = $$v
      },
      expression: "showPicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "show-toolbar": "",
      "columns": _vm.columns,
      "value-key": "versionName"
    },
    on: {
      "confirm": _vm.onConfirm,
      "cancel": _vm.onCancel
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65c823a2","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/equipment/equipmentSetting-info.vue
// module id = vYTi
// module chunks = 51